import React, { useState } from 'react';
import Classes from './RecordTable.module.css';
import backend from '../../../../../../../api';
import { IconButton } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import DropDown from './StatusDropDown/DropDown';

const ProgressIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 512 512"><path d="M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM232 120l0 136c0 8 4 15.5 10.7 20l96 64c11 0 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2 280 120c0-13.3-10.7-24-24-24s-24 10.7-24 24z" /></svg>
)
const CompletedIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 512 512"><path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z" /></svg>
)
const DeleteIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 448 512"><path d="M135.2 17.7L128 32 32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0-7.2-14.3C307.4 6.8 296.3 0 284.2 0L163.8 0c-12.1 0-23.2 6.8-28.6 17.7zM416 128L32 128 53.2 467c1.6 25.3 22.6 45 47.9 45l245.8 0c25.3 0 46.3-19.7 47.9-45L416 128z" /></svg>
)

const MiniGrid = ({ value }) => (
  <>
    <div className={Classes.miniGrid} >
      <div>
        <div className={Classes.gridElem} style={{ opacity: value.infoExposed.name ? 1 : 0.5 }} >
          <img src='/assets/icons/profile.png' alt='icon' />
          <h5>Name</h5>
        </div>
        <div className={Classes.gridElem} style={{ opacity: value.infoExposed.address ? 1 : 0.5 }} >
          <img src='/assets/icons/location.png' alt='icon' />
          <h5>Address</h5>
        </div>
        <div className={Classes.gridElem} style={{ opacity: value.infoExposed.phone ? 1 : 0.5 }} >
          <img src='/assets/icons/phone.png' alt='icon' />
          <h5>Phone</h5>
        </div>
        <div className={Classes.gridElem} style={{ opacity: value.infoExposed.email ? 1 : 0.5 }} >
          <img src='/assets/icons/email.png' alt='icon' />
          <h5>Email</h5>
        </div>
      </div>

      <div>
        <div className={Classes.gridElem} style={{ opacity: value.infoExposed.age ? 1 : 0.5 }} >
          <img src='/assets/icons/clock.png' alt='icon' />
          <h5>Age</h5>
        </div>
        <div className={Classes.gridElem} style={{ opacity: value.infoExposed.postAddress ? 1 : 0.5 }} >
          <img src='/assets/icons/location.png' alt='icon' />
          <h5>Post Address</h5>
        </div>
        <div className={Classes.gridElem} style={{ opacity: value.infoExposed.occupation ? 1 : 0.5 }} >
          <img src='/assets/icons/briefcase.png' alt='icon' />
          <h5>Occupation</h5>
        </div>
        <div className={Classes.gridElem} style={{ opacity: value.infoExposed.maritalStatus ? 1 : 0.5 }} >
          <img src='/assets/icons/marriage.png' alt='icon' />
          <h5>Marital Status</h5>
        </div>
      </div>

      <div>
        <div className={Classes.gridElem} style={{ opacity: value.infoExposed.photo ? 1 : 0.5 }} >
          <img src='/assets/icons/camera.png' alt='icon' />
          <h5>Photo</h5>
        </div>
        <div className={Classes.gridElem} style={{ opacity: value.infoExposed.socialMedia ? 1 : 0.5 }} >
          <img src='/assets/icons/globe.png' alt='icon' />
          <h5>Social Media</h5>
        </div>
        <div className={Classes.gridElem} style={{ opacity: value.infoExposed.courtRecords ? 1 : 0.5 }} >
          <img src='/assets/icons/folder.png' alt='icon' />
          <h5>Court Records</h5>
        </div>
        <div className={Classes.gridElem} style={{ opacity: value.infoExposed.propertyValue ? 1 : 0.5 }} >
          <img src='/assets/icons/home.png' alt='icon' />
          <h5>Property Value</h5>
        </div>
      </div>
    </div>
  </>
)

export default function TableRow({ value, index, userId, handleOpenModal, setRefresh }) {
  const [deletionStatus, setDeletionStatus] = useState(value.deletionStatus);

  const exposedInfo = Object.entries(value?.infoExposed)
    .filter(([_, exposed]) => exposed)
    .map(([key]) => (
      <span key={key} className={Classes.exposedInfoItem}>
        {getIconForInfo(key)}
      </span>
    ));

  console.log(value)

  const reportId = value?.reportId;

  console.log('report is: ', value)

  const handleStatusChange = async (newStatus) => {
    try {
      await backend.post(`/user-information/update-deletion-status/${reportId}/${value.ID}`, {
        deletionStatus: newStatus,
      });
      setDeletionStatus(newStatus);
      setRefresh(prev => !prev); // Trigger refresh to update the UI
    } catch (error) {
      console.error('Error updating deletion status:', error);
    }
  };

  const handleDelete = async () => {
    try {
      await backend.delete(`/user-information/exposures/${value.reportId}/${value._id}`);
      setRefresh(prev => !prev); // Trigger data refresh
    } catch (error) {
      console.error('Error deleting exposure:', error);
    }
  };

  const trueCount = Object.values(value.infoExposed).filter(val => val === true).length;
  const riskLevel = trueCount > 5 ? "High" : trueCount >= 3 ? "Medium" : "Low";

  return (
    <>
      <div className={`${Classes.customerRow}`}>
        <div className={`${Classes.customerInfo} ${Classes.colCustomer}`}>
          <h5>{value.brokerName}</h5>
        </div>
        <div className={`${Classes.spendings} ${Classes.colSpendings}`}>
          <DropDown
            selectedValue={riskLevel}
            options={["High", "Medium", "Low"]}
            isDropDown={false}
          />
        </div>
        <div className={`${Classes.bookings} ${Classes.colBookings}`}>
          <h5 className={Classes.exposedInfoContainer}>
            {exposedInfo.length > 0 ? <MiniGrid value={value} /> : 'None'}
          </h5>
        </div>
        <div className={`${Classes.dateJoined} ${Classes.colDate}`}>
          <div className={Classes.statusCon} >
            {deletionStatus === 'completed' ?
              <CompletedIcon
                width="14px"
                height="14px"
                fill={'#006b32'}
              />
              :
              <ProgressIcon
                width="14px"
                height="14px"
                fill={deletionStatus === 'inProgress' ? '#006b32' : '#ff0000'}
              />
            }
            <h5> {
              deletionStatus === 'inProgress' ? 'In Progress' :
                deletionStatus === 'notStarted' ? 'Not Started' :
                  deletionStatus === 'completed' ? 'Completed' : ''
            } </h5>
          </div>
        </div>
        <div className={`${Classes.actions} ${Classes.colActions}`}>
          <DeleteIcon
            height='18px'
            width='18px'
            fill='#979797'
            cursor='pointer'
            onClick={handleDelete}
          />
        </div>
      </div>

      <div className={`${Classes.customerRowMobile}`}>
        <div className={`${Classes.flexBetween} ${Classes.mb5}`}>
          <div className={`${Classes.flexAlign5}`}>
            <h4>Broker:</h4>
            <h5>{value.brokerName}</h5>
          </div>
          <div className={Classes.flexAlign5}>
            <h4>Status:</h4>
            <div className={Classes.statusCon} >
              {deletionStatus === 'completed' ?
                <CompletedIcon
                  width="14px"
                  height="14px"
                  fill={'#006b32'}
                />
                :
                <ProgressIcon
                  width="14px"
                  height="14px"
                  fill={deletionStatus === 'inProgress' ? '#006b32' : '#ff0000'}
                />
              }
              <h5> {
                deletionStatus === 'inProgress' ? 'In Progress' :
                  deletionStatus === 'notStarted' ? 'Not Started' :
                    deletionStatus === 'completed' ? 'Completed' : ''
              } </h5>
            </div>
          </div>
        </div>
        <div className={`${Classes.flexBetween} ${Classes.mb5}`}>
          <div className={`${Classes.flexAlign5} ${Classes.mb5}`}>
            <h4>Risk:</h4>
            <DropDown
              selectedValue={riskLevel}
              options={["High", "Medium", "Low"]}
              isDropDown={false}
            />
          </div>
          <div className={Classes.flexAlign5}>
            <DeleteIcon
              height='18px'
              width='18px'
              fill='#979797'
              cursor='pointer'
              onClick={handleDelete}
            />
          </div>
        </div>

        <div className={` ${Classes.mb10}`}>
          <h4 className={Classes.mb5} >Exposed:</h4>
          <h5 className={Classes.exposedInfoContainer}>
            {exposedInfo.length > 0 ? <MiniGrid value={value} /> : 'None'}
          </h5>
        </div>
      </div>
    </>
  );
}

function getIconForInfo(key) {
  switch (key) {
    case 'name':
      return <>
        <span className={Classes.exposedIcon}>👤</span>
        <h5>Name</h5>
      </>
    case 'email':
      return <>
        <span className={Classes.exposedIcon}>✉️</span>
        <h5>Email</h5>
      </>
    case 'phone':
      return <>
        <span className={Classes.exposedIcon}>📞</span>
        <h5>Phone</h5>
      </>
    case 'address':
      return <>
        <span className={Classes.exposedIcon}>🏠</span>
        <h5>Address</h5>
      </>
    case 'photo':
      return <>
        <span className={Classes.exposedIcon}>📷</span>
        <h5>Photo</h5>
      </>
    case 'socialMedia':
      return <>
        <span className={Classes.exposedIcon}>🌐</span>
        <h5>Social Media</h5>
      </>
    case 'occupation':
      return <>
        <span className={Classes.exposedIcon}>💼</span>
        <h5>Occupation</h5>
      </>
    case 'courtRecords':
      return <>
        <span className={Classes.exposedIcon}>⚖️</span>
        <h5>Court Records</h5>
      </>
    case 'maritalStatus':
      return <>
        <span className={Classes.exposedIcon}>💍</span>
        <h5>Marital Status</h5>
      </>
    case 'propertyValue':
      return <>
        <span className={Classes.exposedIcon}>🏡</span>
        <h5>Property Value</h5>
      </>
    case 'age':
      return <>
        <span className={Classes.exposedIcon}>🎂</span>
        <h5>Age</h5>
      </>
    case 'postAddress':
      return <>
        <span className={Classes.exposedIcon}>📍</span>
        <h5>Post Address</h5>
      </>
    default:
      return <>
        <span className={Classes.exposedIcon}>ℹ️</span>
        <h5>Info</h5>
      </>
  }
}